import * as React from 'react';
import styled from 'styled-components';
import { PageLoader } from '../../../figma/PageLoader/PageLoader';
import { DefaultCTAButton } from './DefaultCTAButton';
import { LayoutLandingBlog } from './LayoutLandingBlog';
import dynamic from 'next/dynamic';
import { withSuspense } from '../../../hocs/withSuspense';
import { environment } from '@doltech/core/lib/environment/environment';

const LoadingHeader = styled.header`
  top: 0px;
  position: fixed;
  background-color: white;
  left: 0px;
  right: 0px;
  max-width: 100vw;
  z-index: 104;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 8px 24px 0px;
  height: 64px;
`;

const StaticCommonHeader = withSuspense(
  dynamic<any>(
    () => import('../../gen-components/CommonHeader.esm').then((mod) => mod.CommonHeader),
    {
      ssr: true,
      loading: () => <LoadingHeader />,
    }
  )
);

const StaticCommonFooter = withSuspense(
  dynamic<any>(
    () => import('../../gen-components/CommonFooter.esm').then((mod) => mod.CommonFooter),
    {
      ssr: true,
    }
  )
);

export const LandingBlogDetailCommonLayout = (props: any) => {
  const { loading, children, pageProps, renderFooter = null } = props;
  return (
    <LayoutLandingBlog
      renderHeader={
        <StaticCommonHeader
          hideMobileSideBar={false}
          hideMobileBottomNav
          CTAButton={<DefaultCTAButton/>}
          menuData={pageProps?.cmsData?.headerData}
        />
      }
      renderFooter={
        renderFooter || (
          <StaticCommonFooter
            data={pageProps?.cmsData?.footerData}
            shouldRenderDMCA={environment.production}
          />
        )
      }
    >
      {loading ? <PageLoader/> : children}
    </LayoutLandingBlog>
  );
};
